import React, { useState } from "react";
import RegisterButton from "../components/buttons/registerButton";

import { BotMessageSquare, Handshake, Loader2, User } from "lucide-react";
import { useAppState } from "../context/AppStateContext";
import { useNavigate } from "react-router-dom";
import { getComputedStyleVariable } from "../lib/utils";

const loginAskSamJSON = [

  {
    _id: 1,
    type: "COPILOT",
    title: "Clinician",
    description: "I’m here to use my AI powered clinical assistant.",
    image: BotMessageSquare,
  },
  {
    _id: 2,
    type: "USER",
    title: "Patient",
    description: "I'm here to connect, learn, and share",
    image: User,
  },
];


const loginUnitedWeCareJSON = [
  {
    _id: 1,
    type: "USER",
    title: "User",
    description: "I'm here to connect, learn, and share",
    image: User,
  },
  // {
  //   _id: 2,
  //   type: "PARTNER",
  //   title: "Partner",
  //   description: "I'm here to connect, learn, and share",
  //   image: Handshake,
  // },
  {
    _id: 2,
    type: "COPILOT",
    title: "Clinician",
    description: "I'm here to generate patient notes",
    image: BotMessageSquare,
  },
];

const LoginSelector = () => {
  const { state } = useAppState();

  const navigate = useNavigate();
  const searchBarParams = new URLSearchParams(window.location.search);
  const redirectURL = searchBarParams.get("redirect");

  const [loginType, setLoginType] = useState<null | string>();

  const isAskSam =
    window.location.host.includes(".ask-sam.ai") ||
    window.location.host.includes(".asksam.com.au");


  const primaryColorValue = getComputedStyleVariable("--primary");
  const rgbaColor = primaryColorValue
    ? `rgba(${parseInt(primaryColorValue.slice(1, 3), 16)}, ${parseInt(
      primaryColorValue.slice(3, 5),
      16
    )}, ${parseInt(primaryColorValue.slice(5, 7), 16)}, 0.48)` // Adjust the alpha value as needed
    : "";

  const handleNextLogin = () => {
    const params = window.location.href.split("?")[1];
    const hasRedirectURL =
      redirectURL !== null && redirectURL !== undefined && redirectURL !== "";
    const navigateWithParams = (path: string) =>
      navigate(`${path}${hasRedirectURL ? `?${params}` : ""}`);

    switch (loginType) {
      case "USER":
        //   console.log("User");
        if (isAskSam) {
          window.location.href = `https://ai.asksam.com.au/${params ? `?${params}` : ""
            }`;
        } else {
          window.location.href = `https://ai.unitedwecare.com/${params ? `?${params}` : ""
            }`;
        }
        break;
      case "PARTNER":
        navigateWithParams("/login/partner");
        break;
      case "COPILOT":
        if (isAskSam) {
          window.location.href = `https://copilot.asksam.com.au`;
        } else {
          window.location.href = `https://copilot.unitedwecare.com`;
        }
        break;
      default:
        console.log("Something went wrong");
    }
  };

  const loginJSON = isAskSam ? loginAskSamJSON : loginUnitedWeCareJSON;

  return (
    <div className="w-full max-w-[355px] px-1  Login--form ">
      {
        isAskSam ? null : (
          <RegisterButton redirectURL={redirectURL} type={"FLOATING"} />
        )
      }

      <img
        src={state?.appLogoUrl || ""}
        alt="logo"
        width={180}
        className="mx-auto mb-4 xl:hidden"
      />
      <h1 className="text-2xl font-semibold tracking-tight text-center">
        Login
      </h1>
      {/* <p className="text-sm text-slate-500 font-medium text-center">
      Sign up with your email address
    </p> */}
      <h6 className="mt-1 text-center text-base">
        Select which user type you registered as
      </h6>

      <div className="grid gap-3 mt-6">

        {loginJSON?.map((item: any) => {
          return (
            <div
              key={item?._id}
              className={`p-3 rounded-lg border border-gray-300 flex items-start gap-2 cursor-pointer hover:bg-gray-50 ${loginType == item.type
                ? "ring-2 ring-offset-2 ring-violet-500"
                : ""
                }`}
              onClick={() => setLoginType(item.type)}
            >
              <div className="p-1.5 bg-blue-100 rounded-md text-slate-600">
                <item.image className="w-5 h-5" />
              </div>
              <div className="">
                <p className="font-semibold">{item.title}</p>
                <p className="text-sm">{item.description}</p>
              </div>
            </div>
          );
        })}
      </div>

      <button
        style={{
          backgroundColor: !loginType ? rgbaColor : "var(--primary)",
        }}
        className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 bg-primary-500 text-white shadow hover:bg-primary-500/90 h-9 px-4 py-2 mt-4 w-full"
        disabled={!loginType}
        onClick={handleNextLogin}
      >
        Continue
      </button>

      <div className="relative my-4">
        <div className="absolute inset-0 flex items-center">
          <span className="w-full border-t"></span>
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-white px-2 text-slate-400 font-medium">
            Or
          </span>
        </div>
      </div>

      <div className="text-sm text-center text-slate-900 font-semibold">
        Don't have an account? &nbsp;
        <RegisterButton redirectURL={redirectURL} type="INLINE" title="Sign up here" />
      </div>
    </div>
  );
};

export default LoginSelector;
